module.exports = __webpack_public_path__ + "images/marketing/peeps/likes/jody_ferry.jpg";